import { GLD, Observation, UploadTask } from "@nens/brostar/openapi-client";
import {
  EditGLDAdditionTask,
  EditGLDStartRegistrationTask,
  GLDAdditionTask,
  qualityRegimeOptionsType,
} from "@nens/brostar/uploadapi-client";

import { isValidEnum } from "./is-valid-enum";

// EDIT
export const convertGLDToEditTask = ({
  deliveryAccountableParty,
  qualityRegime,
  broId,
  tubeNumber,
  gmwBroId,
}: GLD): EditGLDStartRegistrationTask => {
  return {
    metadata: {
      broId: broId,
      projectNumber: "",
      qualityRegime: isValidEnum(qualityRegimeOptionsType, qualityRegime),
      deliveryAccountableParty: deliveryAccountableParty ?? "",
      correctionReason: "eigenCorrectie",
    },
    sourcedocumentData: {
      objectIdAccountableParty: "",
      gmwBroId: gmwBroId ?? "",
      groundwaterMonitoringNets: [],
      tubeNumber: tubeNumber ?? "",
    },
  };
};

export const convertGLDAdditionToEditTask = (
  {
    observationId,
    processReference,
    measurementInstrumentType,
    evaluationProcedure,
    airPressureCompensationType,
    investigatorKvk,
    observationType,
    validationStatus,
  }: Observation,
  { qualityRegime, broId, deliveryAccountableParty }: GLD
): EditGLDAdditionTask => {
  return {
    metadata: {
      broId: broId,
      projectNumber: "",
      qualityRegime: isValidEnum(qualityRegimeOptionsType, qualityRegime),
      deliveryAccountableParty: deliveryAccountableParty ?? "",
      correctionReason: "eigenCorrectie",
    },
    sourcedocumentData: {
      observationId: observationId ?? "",
      processReference: processReference ?? "",
      measurementInstrumentType: measurementInstrumentType ?? "",
      evaluationProcedure: evaluationProcedure ?? "",
      airPressureCompensationType: airPressureCompensationType ?? "",
      investigatorKvk: investigatorKvk ?? "",
      observationType: observationType ?? "",
      statusQualityControl: validationStatus ?? "",
    },
    timeseriesFile: new Blob([]),
  };
};

// UPLOAD TASK
export const convertGLDUploadTaskToCreateTask = ({
  projectNumber,
  metadata,
  sourcedocumentData,
}: UploadTask): EditGLDAdditionTask | GLDAdditionTask => {
  const { qualityRegime, deliveryAccountableParty, correctionReason } = metadata as {
    [key: string]: string;
  };
  const {
    processReference,
    evaluationProcedure,
    measurementInstrumentType,
    airPressureCompensationType,
    investigatorKvk,
    observationType,
    statusQualityControl,
    gmwBroId,
  } = sourcedocumentData as { [key: string]: string };

  return {
    metadata: {
      qualityRegime: isValidEnum(qualityRegimeOptionsType, qualityRegime),
      deliveryAccountableParty: deliveryAccountableParty,
      correctionReason,
      broId: gmwBroId,
      projectNumber,
    },
    sourcedocumentData: {
      processReference,
      evaluationProcedure,
      measurementInstrumentType,
      airPressureCompensationType,
      investigatorKvk,
      observationType,
      statusQualityControl,
    },
    timeseriesFile: new Blob([]),
  };
};
